import React, { useState, useEffect, useRef } from 'react';
import '../../../Styles/Styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../Styles/CheckboxList.css';
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import BackModal from '../../BasicElements/BackModal';
import ConfirmModal from '../../BasicElements/ConfirmModal';
import { useCookies } from "react-cookie";
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import * as Comp from "../../../Common/CommonComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const AllowanceRateUpdate = (props) => {
  //#region React Hooks
	const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
	const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading....");
	const [editData, setEditData] = useState([]);
	const [departmentList, setDepartmentList] = useState([]);
	const [dayTypeList, setDayTypeList] = useState([]);
	const [workLocationList, setWorkLocationList] = useState([]);
	const [allowanceTypeList, setAllowanceTypeList] = useState([]);
	const [selectedDepartment, setSelectedDepartment] = useState([]);
	const [selectedDayType, setSelectedDayType] = useState([]);
	const [selectedWorkLocation, setSelectedWorkLocation] = useState([]);
	const [selectedAllowanceType, setSelectedAllowanceType] = useState([]);
	const [hasChanges, setHasChanges] = useState(false);
	const [showBackModal, setShowBackModal] = useState(false);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [isActive, setIsActive] = useState(true);
  const [inputError, setInputError] = useState([]);

	useEffect(() => {
		if (props.editData !== null) {
			setEditData({
				ALLOWANCE_RATE_MST_ID: props.editData.ALLOWANCE_RATE_MST_ID === null ? "" : props.editData.ALLOWANCE_RATE_MST_ID,
				DEPT_ID: props.editData.DEPT_ID === null ? "" : props.editData.DEPT_ID,
				DAY_TYPE: props.editData.DAY_TYPE === null ? "" : props.editData.DAY_TYPE,
				WORK_LOCATION: props.editData.WORK_LOCATION === null ? "" : props.editData.WORK_LOCATION,
				ALLOWANCE_TYPE: props.editData.ALLOWANCE_TYPE === null ? "" : props.editData.ALLOWANCE_TYPE,
				HOUR_FROM: props.editData.HOUR_FROM === null ? "" : props.editData.HOUR_FROM,
				HOUR_TO: props.editData.HOUR_TO === null ? "" : props.editData.HOUR_TO,
				THRESHOLD_HOUR: props.editData.THRESHOLD_HOUR === null ? "" : props.editData.THRESHOLD_HOUR,
				AMOUNT: props.editData.AMOUNT === null ? "" : props.editData.AMOUNT,
				REMARK: props.editData.REMARK === null ? "" : props.editData.REMARK,
			})
		}
	}, [props.editData]);
  //#endregion
	
	//#region useEffect to get department list 
	useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get Department list";
			const listItems = [];
			http
				.get("api/allowanceRate/GetDeptList?_sysUser=" + userId, { timeout: 100000 })
				.then((response) => {
				const listItems = response.data.map(department => ({
					key: department.DEPT_ID,
					value: department.DEPT_ID,
					label: `${department.DEPT_NAME}`
				}));
				setDepartmentList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting department list. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting department list. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	}, []);
	
	useEffect(() => {
		if (departmentList.length > 0 && props.editData !== null && props.editData.DEPT_ID) {
			const matchedDept = departmentList.find(dept => dept.value === props.editData.DEPT_ID);
			if (matchedDept) {
				setSelectedDepartment(matchedDept);
			}
		}
	}, [departmentList, props.editData]);
	//#endregion
	
	//#region useEffect to get day type list 
	useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get Day Type list";
			const listItems = [];
			http
				.get("api/allowanceRate/GetDayType?_sysUser=" + userId, { timeout: 100000 })
				.then((response) => {
				const listItems = response.data.map(dayType => ({
					key: dayType.CATEGORY_TYPE_MST_ID,
					value: dayType.CATEGORY_TYPE_MST_ID,
					label: `${dayType.CATEGORY_TYPE_NAME}`
				}));
				setDayTypeList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting day type list. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting day type list. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	}, []);
	
	useEffect(() => {
		if (dayTypeList.length > 0 && props.editData !== null && props.editData.DAY_TYPE) {
			const matchedDayType = dayTypeList.find(dayType => dayType.value === props.editData.DAY_TYPE);
			if (matchedDayType) {
				setSelectedDayType(matchedDayType);
			}
		}
	}, [dayTypeList, props.editData]);
	//#endregion
	
	//#region useEffect to get work location list 
	useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get Work Location list";
			const listItems = [];
			http
				.get("api/allowanceRate/GetWorkLocation?_sysUser=" + userId, { timeout: 100000 })
				.then((response) => {
				const listItems = response.data.map(workLocation => ({
					key: workLocation.CATEGORY_TYPE_MST_ID,
					value: workLocation.CATEGORY_TYPE_MST_ID,
					label: `${workLocation.CATEGORY_TYPE_NAME}`
				}));
				setWorkLocationList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting work location list. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting work location list. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	}, []);
	
	useEffect(() => {
		if (workLocationList.length > 0 && props.editData !== null && props.editData.WORK_LOCATION) {
			const matchedWorkLocation = workLocationList.find(workLocation => workLocation.value === props.editData.WORK_LOCATION);
			if (matchedWorkLocation) {
				setSelectedWorkLocation(matchedWorkLocation);
			}
		}
	}, [workLocationList, props.editData]);
	//#endregion
	
	//#region useEffect to get allowance type list 
	useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get Allowance Type list";
			const listItems = [];
			http
				.get("api/allowanceRate/GetAllowanceType?_sysUser=" + userId, { timeout: 100000 })
				.then((response) => {
				const listItems = response.data.map(allowanceType => ({
					key: allowanceType.CATEGORY_TYPE_MST_ID,
					value: allowanceType.CATEGORY_TYPE_MST_ID,
					label: `${allowanceType.CATEGORY_TYPE_NAME}`
				}));
				setAllowanceTypeList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting allowance type list. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting user allowance type list. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	}, []);
	
	useEffect(() => {
		if (allowanceTypeList.length > 0 && props.editData !== null && props.editData.ALLOWANCE_TYPE) {
			const matchedAllowanceType = allowanceTypeList.find(allowanceType => allowanceType.value === props.editData.ALLOWANCE_TYPE);
			if (matchedAllowanceType) {
				setSelectedAllowanceType(matchedAllowanceType);
			}
		}
	}, [allowanceTypeList, props.editData]);
	//#endregion

	//#region Save Edit
  function saveEditAllowanceRate() {
    let functionName = "";
    try {
      functionName = saveEditAllowanceRate.name;
      setLoading(true, "Updating allowance rate, Please wait....");
			const selectedDepts = selectedDepartment?.key || "";
      const selectedDayTypes = selectedDayType?.key || "";
      const selectedWorkLocations = selectedWorkLocation?.key || "";
      const selectedAllowanceTypes = selectedAllowanceType?.key || "";

      const data = {
        ALLOWANCE_RATE_MST_ID: editData.ALLOWANCE_RATE_MST_ID,
        DEPT_ID: selectedDepts,
        DAY_TYPE: selectedDayTypes,
        WORK_LOCATION: selectedWorkLocations,
        ALLOWANCE_TYPE: selectedAllowanceTypes,
        HOUR_FROM: editData.HOUR_FROM ? editData.HOUR_FROM : "N/A",
				HOUR_TO: editData.HOUR_TO ? editData.HOUR_TO : "N/A",
				THRESHOLD_HOUR: editData.THRESHOLD_HOUR ? editData.THRESHOLD_HOUR : "N/A",
				AMOUNT: editData.AMOUNT,
				REMARK: editData.REMARK,
				ACTIVE_FLAG: isActive ? "Y" : "N", 
        UPDATE_ID: userId,
        FROM_SOURCE: {SOURCE: "WEB", MODULE_ID: props.module },
      };

      http
        .post("api/allowanceRate/AllowanceRateUpdate", data, { timeout: 10000})
        .then((response) => {
					toast.success("Allowance Rate is successfully Updated.");
					props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to update allowance rate. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
    } catch (err) {
      toast.error("Failed to update allowance rate. Please try again.....(receive)");
      common.c_LogWebError(props.page, functionName, err);
    }
  };
  //#endregion

	const inputRequiredHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;
    
		if (name != "Remark") {
			if (val.length === 0 || val.trim().length === 0) {
				setInputError((prevState) => ({
					...prevState,
					[id]: `${name} could not be empty.`,
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					[id]: "",
				}));
			}
		}
		setEditData((prevState) => ({
			...prevState,
			[id]: val,
		}));

		setHasChanges(true);
  }

  const inputTimeHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;
    
    const decimalPattern = /^(?:\d{1,4})(?:\.\d{0,2})?$/;

    const isValid = val === "" || decimalPattern.test(val);

		if (!isValid) {
      return;
    } 
		
		setEditData((prevState) => ({
			...prevState,
			[id]: val,
		}));

		setHasChanges(true);
  }

  const inputAmountHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;
    
    const decimalPattern = /^(0|[1-9]\d*)(\.\d{0,2})?$/;

    const isValid = val === "" || decimalPattern.test(val);

		if (val.length === 0 || val.trim().length === 0) {
			setInputError((prevState) => ({
				...prevState,
				[id]: `${name} could not be empty.`,
			}));
		} else if (!isValid) {
      return;
    } else {
			setInputError((prevState) => ({
				...prevState,
				[id]: "",
			}));
		}
		setEditData((prevState) => ({
			...prevState,
			[id]: val,
		}));

		setHasChanges(true);
  }
		
	const selectDeptHandler = (val) => {
		let functionName = "";
	
		try {
			functionName = selectDeptHandler.name;
			if (val && Object.keys(val).length > 0) {
				setInputError((prevState) => ({
					...prevState,
					DEPARTMENT: "",
					}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					DEPARTMENT: "Department could not be empty.",
				}));
			}
			setSelectedDepartment(val);
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
		setHasChanges(true);
	}
		
	const selectDayTypeHandler = (val) => {
		let functionName = "";
	
		try {
			functionName = selectDayTypeHandler.name;
			if (val && Object.keys(val).length > 0) {
				setInputError((prevState) => ({
					...prevState,
					DAY_TYPE: "",
					}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					DAY_TYPE: "Day Type could not be empty.",
				}));
			}
			setSelectedDayType(val);
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
		setHasChanges(true);
	}
		
	const selectWorkLocationHandler = (val) => {
		let functionName = "";
	
		try {
			functionName = selectWorkLocationHandler.name;
			if (val && Object.keys(val).length > 0) {
				setInputError((prevState) => ({
					...prevState,
					WORK_LOCATION: "",
					}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					WORK_LOCATION: "Work Location could not be empty.",
				}));
			}
			setSelectedWorkLocation(val);
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
		setHasChanges(true);
	}
		
	const selectAllowanceTypeHandler = (val) => {
		let functionName = "";
	
		try {
			functionName = selectAllowanceTypeHandler.name;
			if (val && Object.keys(val).length > 0) {
				setInputError((prevState) => ({
					...prevState,
					ALLOWANCE_TYPE: "",
					}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					ALLOWANCE_TYPE: "Allowance Type could not be empty.",
				}));
			}
			setSelectedAllowanceType(val);
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
		setHasChanges(true);
	}

	//#region Event handle
	const hideModal = () => {
    setEditData([]);
    setSelectedDepartment([]);
    setSelectedDayType([]);
    setSelectedWorkLocation([]);
    setSelectedAllowanceType([]);
    setInputError([]);
		setHasChanges(false);
    props.onHide();
  };

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

	const handleConfirm = () => {
    if (Object.values(inputError).filter(v => v !== "").length === 0){
    	setShowConfirmModal(true);
    }
  };

  const handleConfirmModal = () => {
    saveEditAllowanceRate();
    setShowConfirmModal(false); // Hide confirm modal
		hideModal();
  };

  const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide confirm modal on cancel
  };
	//#endregion

  return (
    <>
    <Modal show={props.showHide} onHide={hideModal} centered size="mg">
			<Modal.Header>
				<div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
					<Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Edit</Modal.Title>
				</div>
			</Modal.Header>

			<Modal.Body>
				<Comp.Select
					id="DEPARTMENT"
					label="Dept.*"
					type="text"
          options={departmentList}
          closeMenuOnSelect={true}
          hideSelectedOptions={false}
					value={selectedDepartment}
          errorMessage={inputError.DEPARTMENT}
					onChange={selectDeptHandler}
				/>

				<Comp.Select
					id="DAY_TYPE"
					label="Day Type*"
					type="text"
          options={dayTypeList}
          closeMenuOnSelect={true}
          hideSelectedOptions={false}
					value={selectedDayType}
          errorMessage={inputError.DAY_TYPE}
					onChange={selectDayTypeHandler}
				/>

				<Comp.Select
					id="WORK_LOCATION"
					label="Work Location*"
					type="text"
          options={workLocationList}
          closeMenuOnSelect={true}
          hideSelectedOptions={false}
					value={selectedWorkLocation}
          errorMessage={inputError.WORK_LOCATION}
					onChange={selectWorkLocationHandler}
				/>

				<Comp.Select
					id="ALLOWANCE_TYPE"
					label="Allowance Type*"
					type="text"
          options={allowanceTypeList}
          closeMenuOnSelect={true}
          hideSelectedOptions={false}
					value={selectedAllowanceType}
          errorMessage={inputError.ALLOWANCE_TYPE}
					onChange={selectAllowanceTypeHandler}
				/>

				<Comp.Input
					id="HOUR_FROM"
					label="Hour From"
					name="Hour From"
					type="text"
					className="form-control"
					value={editData.HOUR_FROM}
					errorMessage={inputError.HOUR_FROM}
					onChange={inputTimeHandler}
				/>

				<Comp.Input
					id="HOUR_TO"
					label="Hour To"
					name="Hour To"
					type="text"
					className="form-control"
					value={editData.HOUR_TO}
					errorMessage={inputError.HOUR_TO}
					onChange={inputTimeHandler}
				/>

				<Comp.Input
					id="THRESHOLD_HOUR"
					label="Threshold Hour"
					name="Threshold Hour"
					type="text"
					className="form-control"
					value={editData.THRESHOLD_HOUR}
					errorMessage={inputError.THRESHOLD_HOUR}
					onChange={inputTimeHandler}
				/>

				<Comp.Input
					id="AMOUNT"
					label="Amount*"
					name="Amount"
					type="text"
					className="form-control"
					value={editData.AMOUNT}
					errorMessage={inputError.AMOUNT}
					onChange={inputAmountHandler}
				/>

				<Comp.Input
					id="REMARK"
					label="Remark"
					name="Remark"
					type="text"
					className="form-control"
					value={editData.REMARK}
					errorMessage={inputError.REMARK}
					onChange={inputRequiredHandler}
				/>
			</Modal.Body>

			<Modal.Footer>
        <div className="onright-container">
            <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
						</Comp.Button>
						
            <Comp.Button id="btnSave" onClick={handleConfirm}>
              <FontAwesomeIcon icon={faCheck} />&nbsp; Save
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>

			{/* Confirmation Modal */}
			<BackModal
        show={showBackModal}
        onHide={handleConfirmBackCancel}
        onConfirm={handleConfirmBack}
				prop="Confirm Navigation"
			>
				Are you sure you want to go back? Your changes may be lost.
			</BackModal>

			<ConfirmModal
				show={showConfirmModal}
				onHide={handleConfirmModalClose}
				onConfirm={handleConfirmModal}
				prop="Confirm to save"
			>
				Are you sure you want to update allowance rate?
			</ConfirmModal>
				
			{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
			<Comp.AlertPopup />
			</>
    );
};

export default AllowanceRateUpdate;
